export default "__VITE_ASSET__C2X7an6b__"